import { useSelector } from 'react-redux'
import { dialogIdForIntentSelector } from '../selectors'

export function useSelectedIntentDialogId(modelId: string, intentId: string) {
  return useSelector(dialogIdForIntentSelector(modelId, intentId))
}
